import { createStore, applyMiddleware, compose } from 'redux'
import { createEpicMiddleware } from 'redux-observable'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import seamlessImmutableTransform from './seamlessImmutableTransform'
import { rootEpic, rootReducer } from './root'

const reduxPersistConfig = {
  key: 'root',
  storage,
  debug: true,
  transforms: [seamlessImmutableTransform],
  blacklist:
    process.env.NODE_ENV === 'production'
    ? [
        // 'login',
        'layer',
        'table',
        'debug',
        // 'map',
        'timestamp',
        'chart',
        'service',
        'object',
        'data',
        'notification',
        'timeSlider'
      ]
      : [
        // 'login',
        // 'map',
        // 'form',
        // 'weather',
         'layer',
        'table',
        'debug',
        'timestamp',
        'chart',
        'service',
        'object',
        'data',
        'notification',
        'timeSlider'
      ]
}

const reducer = persistReducer(reduxPersistConfig, rootReducer)
const epicMiddleware = createEpicMiddleware(rootEpic)
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export default function configureStore () {
  let store = createStore(
    reducer,
    composeEnhancers(applyMiddleware(epicMiddleware))
  )
  let persistor = persistStore(store)
  window.persistor = persistor
  return { store, persistor }
}



// WEBPACK FOOTER //
// ./src/redux/configureStore.js